import EmailIcon from '@material-ui/icons/Email'
import PhoneIcon from '@material-ui/icons/Phone'
import { useState } from 'react'
import styled from 'styled-components'

import { FlexBox } from '../../../components/Base/FlexBox'
import { CopyToClipBoardIcon } from '../../../components/CopyToClipBoard/CopyToClipBoard'
import { Text } from '../../../components/Text/Text'
import { isConsole } from '../../../config/config'
import { formatMobile } from '../../../helpers/formatters'
import { User } from '../../../models/user'
import { blueGray, primaryBlack } from '../../../theme/colors'
import { ProfileCard, ProfileCardItem } from './ProfileCard'
import { ProfileContactEdit } from './ProfileContactEdit'
interface ProfileContactProps {
  user: User
  canEdit: boolean
}

export function ProfileContact({ user, canEdit }: ProfileContactProps) {
  const [showEditMobileModal, setShowEditMobileModal] = useState(false)
  const mobile = formatMobile(user.mobile!) || '-'

  return (
    <>
      <ProfileCard title="Contact" onEdit={canEdit ? () => setShowEditMobileModal(true) : undefined}>
        <ProfileCardItem leftWidth="25px" label={<StyledEmailIcon />} smallGap>
          <FlexBox alignItems="center" gap="10px">
            <Text variant="label2" fontColor={primaryBlack}>
              {user.email}
            </Text>
            {isConsole() && <CopyToClipBoardIcon text={user.email!} />}
          </FlexBox>
        </ProfileCardItem>
        <ProfileCardItem leftWidth="25px" label={<StyledPhoneIcon />} smallGap>
          <FlexBox alignItems="center" gap="10px">
            <Text variant="label2" fontColor={primaryBlack}>
              {mobile}
            </Text>
            {isConsole() && user.mobile && <CopyToClipBoardIcon text={user.mobile} />}
          </FlexBox>
        </ProfileCardItem>
      </ProfileCard>

      {showEditMobileModal && (
        <ProfileContactEdit user={user} handleClose={() => setShowEditMobileModal(false)} />
      )}
    </>
  )
}

const StyledEmailIcon = styled(EmailIcon)`
  width: 20px;
  color: ${blueGray};
`

const StyledPhoneIcon = styled(PhoneIcon)`
  width: 20px;
  color: ${blueGray};
`
